import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { SignIn } from '@/features/auth/sign-in'
import { redirectIfAuthenticated } from '@/lib/require-auth'

const searchSchema = z.object({
  redirect: z.string().optional(),
  token: z.string().optional(),
  error: z.string().optional(),
  return_to: z.string().optional(),
  ref: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/sign-in')({
  validateSearch: searchSchema,
  beforeLoad: async ({ search }) => {
    await redirectIfAuthenticated({
      redirect: search.redirect,
      token: search.token,
    })
  },
  component: SignIn,
})
